<template>
  <div class="course-type-field row no-gutters">
    <div
      v-for="(type, i) in types"
      :key="i"
      class="course-type col-12 col-md-6"
      :class="{'selected': courseType == type.value}"
      @click="courseType = type.value"
    >
      <div class="outer">
        <div class="border">
          <div class="inner">
            <div class="icon-wrap">
              <icon :icon="type.value.toLowerCase()" class="icon" />
            </div>
            <div class="text-wrap">
              <span class="text">{{ type.label }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <input type="hidden" name="type" :value="courseType" />
  </div>
</template>

<script>
export default {
  props: {
    course: { type: Object, required: true },
    types: { type: Array, required: true },
    value: { type: String }
  },
  data() {
    return {
      courseType: null
    };
  },
  watch: {
    value(val) {
      this.courseType = val;
    },
    courseType(val) {
      this.$emit("input", val);
    }
  },
  mounted() {
    this.courseType = this.value;
  }
};
</script>
